import "./css/UnderstandOurServices.css";
import "./css/IIITHUnderstandUs.css";
const videoUrls = ["https://youtu.be/SK9xGM-UZmI"];

const IIITHUnderstandUs = () => {
  const getYouTubeID = (url) => {
    const match = url.match(
      /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|shorts\/)|youtu\.be\/)([\w-]{11})/
    );
    return match ? match[1] : "";
  };

  return (
    <div className="intern-bg">
      <div className="" style={{ display: "flex", justifyContent: "center" }}>
        <p className="heading-text-3">Understand our program</p>
      </div>
      <div className="video-container-2">
        <div className="" style={{ width: "100%" }}>
          <div
            style={{ width: "100%", textAlign: "center", padding: "20px 0" }}
          >
            <div
              style={{
                position: "relative",
                width: "90%",
                maxWidth: "800px",
                margin: "auto",
              }}
            >
              <iframe
                width="100%"
                height="400"
                src={`https://www.youtube.com/embed/${getYouTubeID(
                  videoUrls[0]
                )}`}
                title={`Video 1`}
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen
                style={{
                  borderRadius: "12px",
                  boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
                }}
              ></iframe>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default IIITHUnderstandUs;
